import React from 'react';
import { Box } from '@mui/material';
import WavingHandIcon from '@mui/icons-material/WavingHand';
import PercentIcon from '@mui/icons-material/Percent';
import EventIcon from '@mui/icons-material/Event';
import PeopleIcon from '@mui/icons-material/People';
import PlaceIcon from '@mui/icons-material/Place';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {
    BannerContainer,
    BannerContent,
    BannerHeader,
    WelcomeIcon,
    BannerTitle,
    BannerSubtitle,
    BenefitsList,
    BenefitItem,
    JoinButton,
    FreeLabel,
} from './styled';

const WelcomeBannerView = ({
    community,
    venues = [],
    members = [],
    upcomingEvents = [],
    onJoinClick,
}) => {
    const activeVenuesCount = venues.filter(v => v.status === 'AC').length;
    const activeMembersCount = members.filter(m => m.status === 'AC').length;
    const upcomingEventsCount = upcomingEvents.length;

    const benefits = [
        {
            icon: <PercentIcon />,
            label: 'Member Discounts',
            value: 'Exclusive rates at partner venues',
        },
        {
            icon: <PlaceIcon />,
            label: `${activeVenuesCount} Partner Venue${activeVenuesCount !== 1 ? 's' : ''}`,
            value: 'Book desks and meeting rooms',
        },
        {
            icon: <EventIcon />,
            label: 'Community Events',
            value: upcomingEventsCount > 0 
                ? `${upcomingEventsCount} upcoming event${upcomingEventsCount !== 1 ? 's' : ''}`
                : 'Networking & workshops',
        },
        {
            icon: <PeopleIcon />,
            label: `${activeMembersCount} Members`,
            value: 'Connect & collaborate',
        },
    ];

    return (
        <BannerContainer>
            <BannerContent>
                <BannerHeader>
                    <WelcomeIcon>
                        <WavingHandIcon />
                    </WelcomeIcon>
                    <Box>
                        <BannerTitle>
                            Welcome to {community?.name || 'this community'}!
                        </BannerTitle>
                        <BannerSubtitle>
                            Join our community to unlock exclusive benefits, connect with like-minded professionals, 
                            and access discounted workspace at our partner venues.
                        </BannerSubtitle>
                    </Box>
                </BannerHeader>

                <BenefitsList>
                    {benefits.map((benefit, index) => (
                        <BenefitItem key={index}>
                            <Box className="benefit-icon">
                                {benefit.icon}
                            </Box>
                            <Box className="benefit-text">
                                <span className="benefit-label">{benefit.label}</span>
                                <span className="benefit-value">{benefit.value}</span>
                            </Box>
                        </BenefitItem>
                    ))}
                </BenefitsList>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
                    <JoinButton onClick={() => {
                        // Trigger the join dialog by clicking the JoinCommunityFab
                        const joinWrapper = document.querySelector('[data-join-button]');
                        if (joinWrapper) {
                            const fabButton = joinWrapper.querySelector('button');
                            if (fabButton) fabButton.click();
                        } else if (onJoinClick) {
                            onJoinClick();
                        }
                    }}>
                        Join {community?.name || 'Community'}
                    </JoinButton>
                    <FreeLabel>
                        <CheckCircleIcon />
                        Free to join
                    </FreeLabel>
                </Box>
            </BannerContent>
        </BannerContainer>
    );
};

export default WelcomeBannerView;
